/* 
 * <div.tabbed-content>
 *		<ul.tabs-menu>
 *			<li.tab-nav-item>
 *				<button data-tab=TABNUM>
 *		
 *		<ul.tabs>
 *			<div.tab.tab-TABNUM>
 *
 */
(function() {
	document.querySelectorAll('.tabbed-content').forEach(tc => {
		let currentTab = -1;
		const currentClass = 'current-tab-nav-item';
		const currentTabClass = 'current-tab';
		
		const $tabsHolder = tc.querySelector('.tabs');
		if(! $tabsHolder )
			return;
			
		const $tabsMenu = tc.querySelector(':scope > .tabs-menu');
		
		const $tabs = $tabsHolder.querySelectorAll('.tab');
		const $navItems = $tabsMenu.querySelectorAll('.tab-nav-item');
		
		$navItems.forEach((nv, index) => {
			var button = nv.querySelector('button');
			button.addEventListener('click', event => {
				event.preventDefault();
				var tab = parseInt(event.currentTarget.dataset.tab, 10);
				if( tab === currentTab )
					return;
		
				$tabsHolder.querySelectorAll('.'+ currentTabClass).forEach(nv1 => {
					nv1.classList.remove(currentTabClass);
				});
				
				$navItems.forEach(nv2 => {
					nv2.classList.remove(currentClass);
				});
				
				if( currentTab !== -1 )
					$tabsHolder.querySelector(':scope > .tab-'+ currentTab).classList.remove(currentTabClass);
		
				currentTab = tab;
				event.currentTarget.parentNode.classList.add(currentClass);
				$tabsHolder.querySelector(':scope > .tab-'+ currentTab).classList.add(currentTabClass);
				
				
				tc.dispatchEvent(new Event('tabchange'));
			});
			

			if( index === 0 ) {
				var clickEvent = new Event('click');
				button.dispatchEvent(clickEvent);
			}
		});
		
		
		const clickEvent = new Event('click');
		let activeOnLoad = $tabsMenu.querySelector('.active-on-load button');
		if(! activeOnLoad)
			activeOnLoad = $navItems[0].querySelector('button');
			
		activeOnLoad.dispatchEvent(clickEvent);		
	});
})();